import React from 'react'

const FormAnalyticsCard = ({ cardStyle = {}, textData = [], onClick }) => {
  return (
    <div
      style={{
        width: '100%',
        height: '71px',
        boxShadow: ' 3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        display: 'flex',
        background: '#ececec',
        ...cardStyle,
      }}
      className={`rounded-1 cursor-pointer`}
      tabIndex={0}
      title="Click to see Details"
      onClick={onClick}
    >
      <div style={{ fontSize: '14px' }} className="d-flex  align-items-center w-100">
        {textData.map((info, idx) => (
          <p
            style={{
              ...info.styles,
              textOverflow: '...more',
            }}
            className="line-clamp-2 m-0"
            key={idx}
          >
            {info?.name}
          </p>
        ))}
      </div>
    </div>
  )
}

export default FormAnalyticsCard
